import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuditLogState } from '../reducers/audit-log.reducer';

/**
 * select Audit Log State
 */
export const selectAuditLogState = createFeatureSelector<AuditLogState>('auditLog');

/**
 * select Audit Logs
 */
export const selectAuditLogs = createSelector(selectAuditLogState, state => state.entities);

/**
 * select Audit Log backend pages
 */
export const selectBackendPages = createSelector(selectAuditLogState, state => state.backendPages);

/**
 * select Audit Log backend page size
 */
export const selectBackendPageSize = createSelector(selectAuditLogState, state => state.backendPageSize);

/**
 * select Audit Log pagination id
 */
export const selectPaginationId = createSelector(selectAuditLogState, state => state.paginationId);

/**
 * select Audit Log current page
 */
export const selectCurrentPage = createSelector(selectAuditLogState, state => state.currentPage);

/**
 * select Audit Log page size
 */
export const selectPageSize = createSelector(selectAuditLogState, state => state.pageSize);

/**
 * select Audit Log total count
 */
export const selectTotalCount = createSelector(selectAuditLogState, state => state.totalCount);

/**
 * select Audit Log display items
 */
export const selectAuditLogDisplayedItems = createSelector(selectAuditLogState, state => {
    const backendPageStart = Math.floor((state.currentPage * state.pageSize) / state.backendPageSize);
    // Last item of current page
    const backendPageEnd = Math.floor(((state.currentPage + 1) * state.pageSize - 1) / state.backendPageSize);
    const localStart = (state.currentPage % (state.backendPageSize / state.pageSize)) * state.pageSize;

    let itemIds = state.backendPages[backendPageStart] || [];
    if (backendPageStart !== backendPageEnd) {
        itemIds = itemIds.concat(state.backendPages[backendPageEnd] || []);
    }
    const paginatedIds = itemIds.slice(localStart, localStart + state.pageSize);

    return paginatedIds.map(id => state.entities[id]);
});

/**
 * select Audit Log Loading
 */
export const selectAuditLogLoading = createSelector(selectAuditLogState, state => state.loading);

/**
 * select Audit Log Loading
 */
export const selectAuditLogError = createSelector(selectAuditLogState, state => state.error);
